import React, { useRef } from "react";
import DownloadExcel from "../../Extra/DownloadExcel";
import { secondsToHHMM, sumArrayOfObjects } from "../../Utilitie";

const LobbyWiseOutsideRest = ({ data }) => {
  const lobbyWiseSum = sumArrayOfObjects(
    data,
    ["hq_crew_lobby", "hq_lobby", "hq_year"],
    [],
    "group_id",
  );
  lobbyWiseSum.sort((a, b) => b.hq_occurence - a.hq_occurence);
  // console.log(
  //   sumArrayOfObjects(
  //     data,
  //     ["hq_crew_lobby", "hq_lobby", "hq_month"],
  //     [],
  //     "group_id",
  //   ),
  // );
  const tableRef = useRef();
  return (
    <div className="newUiBody">
      <div
        className="table-responsive  p-0 m-0"
        style={{ maxHeight: "500px", overflow: "auto" }}
      >
        <table
          className="table newUiTable table-striped table-hover  "
          ref={tableRef}
        >
          <thead className="sticky-top " style={{ zIndex: 2 }}>
            <tr className="table-dark  ">
              <th>SNo</th>
              <th>Year</th>

              <th>Lobby</th>
              <th>Crew Lobby</th>
              <th>Occurence</th>
              <th>Total Rest</th>
            </tr>
          </thead>
          <tbody>
            {data &&
              lobbyWiseSum.map((obj, ind) => {
                let showTotalRow = false;
                let sumResult = null;

                // Check if month changes compared to previous row
                if (
                  ind > 0 &&
                  (lobbyWiseSum[ind - 1].hq_month !== obj.hq_month ||
                    lobbyWiseSum.length - 1 === ind)
                ) {
                  showTotalRow = true;

                  // Filter all rows with the previous month and same year
                  const rowsToSum = lobbyWiseSum.filter(
                    (d) =>
                      d.hq_month === lobbyWiseSum[ind - 1].hq_month &&
                      d.hq_year === lobbyWiseSum[ind - 1].hq_year,
                  );

                  // Sum numeric values
                  sumResult = rowsToSum.reduce((acc, curr) => {
                    for (let key in curr) {
                      if (typeof curr[key] === "number") {
                        acc[key] = (acc[key] || 0) + curr[key];
                      }
                    }
                    return acc;
                  }, {});

                  // console.log(sumResult);
                }

                return (
                  <React.Fragment key={ind}>
                    {ind === lobbyWiseSum.length - 1 ||
                      (showTotalRow && (
                        <tr
                          className="table-dark "
                          style={{ fontSize: "bold" }}
                        >
                          <td colSpan={4} className="text-center fw-bold">
                            Total for {lobbyWiseSum[ind - 1].hq_month}
                          </td>

                          <td>{sumResult.hq_occurence}</td>
                          <td>{sumResult.hq_total_rest}</td>
                        </tr>
                      ))}

                    <tr
                      className={obj.wh_lobby === "TOTAL" ? "table-dark" : ""}
                    >
                      <td>{ind + 1}</td>
                      <td>{obj.hq_year}</td>

                      <td>{obj.hq_lobby}</td>
                      <td>{obj.hq_crew_lobby}</td>
                      <td>{obj.hq_occurence}</td>
                      <td>{secondsToHHMM(obj.hq_total_rest)}</td>
                    </tr>
                    {ind === lobbyWiseSum.length - 1 && showTotalRow && (
                      <tr className="table-dark sticky-bottom">
                        <td colSpan={4} className="text-center fw-bold">
                          Total for {lobbyWiseSum[ind - 1].hq_month}
                        </td>
                        <td>{sumResult.hq_occurence}</td>
                        <td>{secondsToHHMM(sumResult.hq_total_rest)}</td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
          </tbody>
        </table>
      </div>
      <DownloadExcel tableRef={tableRef} fileName={`crew utilization`} />
    </div>
  );
};
export default LobbyWiseOutsideRest;
